import type { Filter } from '@cubejs-client/core'
import {
  DRIFT_SITE_CONCIERGE_DIMENSIONS,
  DRIFT_SITE_CONCIERGE_SEARCH_DIMENSIONS,
  SiteConciergeSearchTableQuery,
  useCubeReportPageFiltersContext,
} from 'cube'
import moment from 'moment'

import { useToast } from '@driftt/dds'
import { CubeQueryBuilder, useCubeExport } from '@driftt/dds.reports'

import useTimePeriod from 'hooks/useTimePeriod'
import { isNilOrEmpty } from 'utils/ramda'

export const useSiteConciergeSearchCSVExport = (searchFilter?: string) => {
  const timePeriod = useTimePeriod()
  const toast = useToast()
  const { pageFilters = [] } = useCubeReportPageFiltersContext()

  const filters: Filter[] = [
    {
      member: DRIFT_SITE_CONCIERGE_DIMENSIONS.ACTION,
      operator: 'equals',
      values: ['sendMessage'],
    },
    {
      member: DRIFT_SITE_CONCIERGE_DIMENSIONS.EVENT_NAME,
      operator: 'equals',
      values: ['SearchApp'],
    },
    ...pageFilters,
  ]

  if (!isNilOrEmpty(searchFilter)) {
    filters.push({
      or: [
        {
          member: DRIFT_SITE_CONCIERGE_SEARCH_DIMENSIONS.SEARCH_QUERY,
          operator: 'contains',
          values: [searchFilter],
        },
        {
          member: DRIFT_SITE_CONCIERGE_SEARCH_DIMENSIONS.SEARCH_RESULT,
          operator: 'contains',
          values: [searchFilter],
        },
      ],
    })
  }

  const siteConciergeSearchCSVExportCubeQuery = new CubeQueryBuilder({
    query: SiteConciergeSearchTableQuery,
  })
    .withTimeDimensions([
      {
        dimension: DRIFT_SITE_CONCIERGE_DIMENSIONS.EVENT_SENT_AT,
        dateRange: [
          moment(timePeriod.startDate).format('YYYY-MM-DD'),
          moment(timePeriod.endDate).format('YYYY-MM-DD'),
        ],
      },
    ])
    .withFilters(filters)
    .build()

  const { isInitialLoading: isDownloadingExport, refetch: exportCubeData } =
    useCubeExport({
      query: siteConciergeSearchCSVExportCubeQuery,
      enabled: false,
      exportFileName: `Site concierge Intelligent Search export ${moment(
        timePeriod.startDate
      ).format('YYYY-MM-DD')} to ${moment(timePeriod.endDate).format(
        'YYYY-MM-DD'
      )}`,
      onExportSuccess() {
        toast({
          message: 'CSV successfully created.',
          variant: 'success',
        })
      },
      onExportError() {
        toast({
          message: 'There was a error while trying to create the CSV.',
          variant: 'error',
        })
      },
    })

  return {
    isDownloadingExport,
    exportCubeData,
  }
}
